export default {
  chat_state_typing: '{peer} is typing...',
  chat_state_group_conversation: '{peer} are typing...',
  chat_state_group_conversation_one_other: '{peer} and 1 other are typing...',
  chat_state_group_conversation_others:
    '{peer} and {count} other{plural} are typing...',
};
